import React, { useEffect, useState } from "react";
import { unstable_HistoryRouter, useNavigate } from "react-router-dom";
import AdminNavBarMain from "./AdminNavBarMain";
import Table from "react-bootstrap/Table";
import axios from ".././axios-interceptor";
import * as XLSX from "xlsx";
import FileSaver from "file-saver";
import {
  AUDITOR_ROLE,
  base_url,
  LOAN_CURRENCY_TYPE_BHD,
  LOAN_CURRENCY_TYPE_USD,
} from "./../utilities";
import Skeleton from "react-loading-skeleton";
import { toast } from "react-toastify";
import { decrypt } from "../utils";
import Cookies from 'js-cookie';

const ListofBusinesses = (props) => {
  let ltwo = props.ltwo;
  const [defaultValue, setDefaultValue] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [sortOrder, setSortOrder] = useState({ column: null, direction: null });

  const [listofBusinesses, setListofBusinesses] = useState([]);
  const [firstValue, setFirstValue] = useState([]);
  const [secondValue, setSecondValue] = useState([]);
  const [thirdValue, setThirdValue] = useState([]);
  const [fourthValue, setFourthValue] = useState([]);
  const [fifthValue, setFifthValue] = useState([]);
  const [allBusinessFilter, setAllBusinessFilter] = useState([]);

  useEffect(() => {
    if (!Cookies.get("User_Accesstoken_Admin")) {
      navigate("/adminlogin");
    }
    axios
      .post(base_url + "business-master/get_business_data")
      .then((res) => {
        let data = res.data.data;
        if (data !== "" || data !== undefined) {
          data.forEach((each_record, index) => {
            each_record.serial_number = index + 1;
          });
          setLoading(false);
          setListofBusinesses(data);
          setAllBusinessFilter(data);
          setFirstValue(data);
          setSecondValue(data);
          setThirdValue(data);
          setFourthValue(data);
          setFifthValue(data);
          setDisplayedData(data);
        }
      })
      .catch((err) => {
        if (err.response.statusText == "Unauthorized") {
          toast.error("Your session has expired. Please login again", {
            toastId: 7,
          });
          Cookies.remove("User_Accesstoken_Admin");
          Cookies.remove("User_Refreshtoken_Admin");
          navigate("/adminlogin");
        }
      });
  }, []);

  const columns = [
    { title: "Sr.No", sort: "serial_number" },
    { title: "Business Name", sort: "business_name" },
    { title: "Ref No", sort: "business_reference_no" },
    {
      title: "Country",
      sort: "country",
      currency: "admin_request_loan_currency",
    },
    {
      title: "Total Loan Amount",
      field: "total_loan_amount",
      currency: "admin_request_loan_currency",
    },
    { title: "Monthly Return", field: "avg_monthly_return" },
    {
      title: "Total Principal Repaid",
      field: "total_repaid",
      currency: "admin_request_loan_currency",
    },
    {
      title: "Actions",
      field: "image",
      image: "./images/icons/blue_eye.svg",
      datatopass: "business_reference_no",
    },
  ];
  const handleSort = (column) => {
    let direction = "asc";
    if (sortOrder.column === column && sortOrder.direction === "asc") {
      direction = "desc";
    }
    setSortOrder({ column, direction });

    const sortedData = [...allBusinessFilter].sort((a, b) => {
      const columnA = a[column];
      const columnB = b[column];
      if (typeof columnA === "string" && typeof columnB === "string") {
        return direction === "asc"
          ? columnA.localeCompare(columnB)
          : columnB.localeCompare(columnA);
      } else if (typeof columnA === "number" && typeof columnB === "number") {
        return direction === "asc" ? columnA - columnB : columnB - columnA;
      } else {
        return 0;
      }
    });
    setAllBusinessFilter(sortedData);
  };
  function exportToExcel() {
    let sample_data_array = [];
    allBusinessFilter.forEach((elem) => {
      let xl_object = {
        "Business Name": elem.business_name,
        "Ref No": elem.business_reference_no,
        "Country": elem.country,
        "Total Loan Amount BHD": elem.total_loan_amount_bhd,
        "Total Loan Amount USD": elem.total_loan_amount_usd,
        "Monthly Return BHD": elem.avg_monthly_return_bhd,
        "Monthly Return USD": elem.avg_monthly_return_usd,
        "Total Principal Repaid BHD": elem.total_principal_bhd,
        "Total Principal Repaid USD": elem.total_principal_usd,
      };
      sample_data_array.push(xl_object);
    });
    // create the data that you want to write to the excel file
    const data = sample_data_array;
    // create a worksheet and add the data to it
    const worksheet = XLSX.utils.json_to_sheet(data);
    // create a workbook and add the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    // create the excel file and save it to the user's device
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    // const fileExtension = ".xlsx";
    const fileName = "all_businesses_list.xlsx";
    const file = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: fileType }
    );
    FileSaver.saveAs(file, fileName);
  }
  const goToAdminDashboard = () => {
    navigate("/admindashboard");
  };
  const clearFilters = () => {
    setDefaultValue(true);
    setAllBusinessFilter(listofBusinesses);
    setFirstValue(listofBusinesses);
    setSecondValue(listofBusinesses);
    setThirdValue(listofBusinesses);
    setFourthValue(listofBusinesses);
    setFifthValue(listofBusinesses);
    setInitialValue('')
    setSecondFilterValue('')
    setThirdFilterValue('')
  };


  const [initialValue, setInitialValue] = useState('')
  const [secondFilterValue, setSecondFilterValue] = useState('')
  const [thirdFilterValue, setThirdFilterValue] = useState('');
  const[displayedData,setDisplayedData]=useState([]);
  const handleChangeAllInput=(e)=>{
    const value = e.target.value;
if(value.length>2)
{
  axios
      .post(base_url+'business-master/get_business_data',{filter_value:value})
      .then((res)=>{
        let data=res.data.data;
        if (data && data.length > 0) {
          setAllBusinessFilter(data);
          setInitialValue(data);         
           setSecondValue(data);
      setThirdValue(data);
      setFourthValue(data);
      setFifthValue(data);
        }
      })
      .catch((err)=>{
        console.log(err,"error");
      })
}
if(value.length===0)
{
  setAllBusinessFilter(displayedData);
}
  }
  const handleChangeInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setDefaultValue(false);
    if (name === "busns_name" && secondFilterValue ==='' && thirdFilterValue ==='') {
      setInitialValue("busns_name")
      let f = firstValue.filter((item) => {
        if (value === item.business_name) {
          return item;
        }
        if (value === "All") {
          return item;
        }
      });
      setAllBusinessFilter(f);
      setSecondValue(f);
      setThirdValue(f);
      setFourthValue(f);
      setFifthValue(f);
    }
    if (name === "refNo" && initialValue ==='' && thirdFilterValue ==='') {
      setSecondFilterValue("refNo")
      let f = secondValue.filter((item) => {
        if (value === item.business_reference_no) {
          return item;
        }
        if (value === "All") {
          return item;
        }
      });
      setAllBusinessFilter(f);
      setFirstValue(f);
      setThirdValue(f);
      setFourthValue(f);
      setFifthValue(f);
    }
    if (name === "refNo" && initialValue !=='' ) {
      let f = secondValue.filter((item) => {
        if (value === item.business_reference_no) {
          return item;
        }
        if (value === "All") {
          return item;
        }
      });
      setAllBusinessFilter(f);
      setThirdValue(f);
      setFourthValue(f);
      setFifthValue(f);
    }
    if (name === "refNo" && thirdFilterValue !=='' ) {
      let f = secondValue.filter((item) => {
        if (value === item.business_reference_no) {
          return item;
        }
        if (value === "All") {
          return item;
        }
      });
      setAllBusinessFilter(f);
      setFourthValue(f);
      setFifthValue(f);
    }

    if (name === "country" &&  initialValue ==='' && secondFilterValue ==='') {
      setThirdFilterValue("country")
      let f = thirdValue.filter((item) => {
        if (value === item.country) {
          return item;
        }
        if (value === "All") {
          return item;
        }
      });
      setAllBusinessFilter(f);
      setFirstValue(f);
      setSecondValue(f);
      setFourthValue(f);
      setFifthValue(f);
    }
    
  };
  const uniqueBusinesses = [...new Set(firstValue.map((d) => d.business_name))];
  const uniqueBusRefNo = [
    ...new Set(secondValue.map((d) => d.business_reference_no)),
  ];
  const uniqueCountry = [...new Set(thirdValue.map((d) => d.country))];

  const dataTopass = (props) => {
    navigate("/particularbusinessloanlist", { state: { props } });
  };

  const [roleCode, setRoleeCode] = useState(() => {
    const storedRoleeCode = Cookies.get('role_code');
    return storedRoleeCode ? storedRoleeCode : '';
  });

  useEffect(()=>{
    if (roleCode) {
      try {
        const decryptedValueData = decrypt(roleCode);
        setRoleeCode(decryptedValueData);
      } catch (error) {
        console.error('Decryption error:', error);
      }
    }
  },[])

  return (
    <div>
      <div>
        <AdminNavBarMain />
      </div>

      <div className="row p-5 pb-0 pt-1 ">
        <div className="d-flex justify-content-between ">
          <div className="col d-flex justify-content-between my-xxl-2  my-lg-1">
            <h5
              className="admin_serv "
              onClick={() => goToAdminDashboard(true)}
            >
              <img
                src="./images/left_arrow.svg"
                alt=""
                className="indiv_loan_dtls"
              />
              &nbsp; All Businesses
            </h5>
            <div className="col-md-3">
              <input
              id="all"
              name="all"
              type="text"
              className="form-control rounded px-4 py-3 border-0 w-100"
              placeholder="Search by keywords"
              onChange={(e)=>handleChangeAllInput(e)}
              />
            </div>
          </div>
        </div>
        <div className="row mb-3 mt-2 gap-3">
          <div className="col-lg">
            <label htmlFor="busns_name" className="form-label">
              <p>Search by Business</p>
            </label>
            <select
              id="busns_name"
              className="form-select dropdn_select_cls  shadow-ben APNL_option_flds"
              aria-label="form-select example"
              name="busns_name"
              autoComplete="off"
              onChange={handleChangeInput}
            >
              <option selected={defaultValue}>All</option>
              {uniqueBusinesses.map((type) => {
                return <option key={type}>{type}</option>;
              })}
            </select>
          </div>
          <div className="col-lg">
            <label htmlFor="refNo" className="form-label">
              <p>Ref No.</p>
            </label>
            <select
              id="refNo"
              className="form-select dropdn_select_cls  shadow-ben APNL_option_flds"
              aria-label="form-select example"
              name="refNo"
              autoComplete="off"
              onChange={handleChangeInput}
            >
              <option selected={defaultValue}>All</option>
              {uniqueBusRefNo.map((refno) => {
                return <option key={refno}>{refno}</option>;
              })}
            </select>
          </div>
          <div className="col-lg">
            <label htmlFor="country" className="form-label">
              <p>Country</p>
            </label>
            <select
              className="form-select  dropdn_select_cls shadow-ben APNL_option_flds"
              id="country"
              onChange={handleChangeInput}
              name="country"
            >
              <option selected={defaultValue}>All</option>

              {uniqueCountry.map((country) => {
                return <option key={country}>{country}</option>;
              })}
            </select>
          </div>

          <div className="col-lg-4 btn_style">
            <span className="pe-4">
              <button className="blue_btn " onClick={clearFilters}>
                Clear All Filters
              </button>
            </span>
            <button className="blue_btn" onClick={exportToExcel} disabled={roleCode===AUDITOR_ROLE}>
              Download XLS
            </button>
          </div>
        </div>

        <div className="admin_all_busns_tabl">
          <Table
            striped
            //  bordered
            className="my_loan_table bg-white"
          >
            <thead className="">
              <tr>
                {columns.map((header) => (
                  <th
                    className="Cpointer"
                    key={header.sort}
                    onClick={() => handleSort(header.sort)}
                  >
                    {ltwo || loading ? (
                      <Skeleton width={100} height={15} />
                    ) : header.title !== "Actions" &&
                      header.title !== "Total Loan Amount" &&
                      header.title !== "Monthly Return" &&
                      header.title !== "Total Principal Repaid" ? (
                      <> {header.title}&#9662;</>
                    ) : (
                      header.title
                    )}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {allBusinessFilter.map((service, index) => {
                return (
                  <tr key={index}>
                    <td className="pt-3">
                      {ltwo || loading ? (
                        <Skeleton width={100} height={15} />
                      ) : (
                        service.serial_number
                      )}
                    </td>
                    <td className="pt-3">
                      {ltwo || loading ? (
                        <Skeleton width={100} height={15} />
                      ) : (
                        service.business_name
                      )}
                    </td>
                    <td className="pt-3">
                      {ltwo || loading ? (
                        <Skeleton width={100} height={15} />
                      ) : (
                        service.business_reference_no
                      )}
                    </td>
                    <td className="pt-3">
                      {ltwo || loading ? (
                        <Skeleton width={100} height={15} />
                      ) : (
                        service.country
                      )}
                    </td>
                    <td>
                      {ltwo || loading ? (
                        <Skeleton width={100} height={15} />
                      ) : (
                        <div className="row">
                          <div className="col ">
                            <div className=" u_tab_data">
                              {" "}
                              {service.total_loan_amount_usd >= 0
                                ? LOAN_CURRENCY_TYPE_USD
                                : "-"}{" "}
                            </div>
                            <div>
                              {service.total_loan_amount_bhd >= 0
                                ? LOAN_CURRENCY_TYPE_BHD
                                : "-"}{" "}
                            </div>
                          </div>
                          <div className="col">
                            <div className=" u_tab_data text-end">
                              {Number(
                                service.total_loan_amount_usd
                              ).toLocaleString()}{" "}
                            </div>
                            <div className="  text-end">
                              {Number(
                                service.total_loan_amount_bhd
                              ).toLocaleString()}
                            </div>
                          </div>
                        </div>
                      )}
                    </td>

                    <td>
                      {ltwo || loading ? (
                        <Skeleton width={100} height={15} />
                      ) : (
                        <div className="row">
                          <div className="col ">
                            <div className=" u_tab_data">
                              {" "}
                              {service.avg_monthly_return_usd >= 0
                                ? LOAN_CURRENCY_TYPE_USD
                                : "-"}{" "}
                            </div>
                            <div>
                              {service.avg_monthly_return_bhd >= 0
                                ? LOAN_CURRENCY_TYPE_BHD
                                : "-"}{" "}
                            </div>
                          </div>
                          <div className="col">
                            <div className=" u_tab_data text-end">
                              {service.avg_monthly_return_usd}%
                            </div>
                            <div className="  text-end">
                              {service.avg_monthly_return_bhd}%
                            </div>
                          </div>
                        </div>
                      )}
                    </td>

                    <td>
                      {ltwo || loading ? (
                        <Skeleton width={100} height={15} />
                      ) : (
                        <div className="row">
                          <div className="col ">
                            <div className=" u_tab_data ">
                              {" "}
                              {service.total_principal_usd >= 0
                                ? LOAN_CURRENCY_TYPE_USD
                                : "-"}{" "}
                            </div>
                            <div>
                              {service.total_principal_bhd >= 0
                                ? LOAN_CURRENCY_TYPE_BHD
                                : "-"}{" "}
                            </div>
                          </div>
                          <div className="col">
                            <div className=" u_tab_data text-end">
                              {Number(
                                Math.floor(
                                  parseFloat(service.total_principal_usd)
                                )
                              ).toLocaleString()}
                            </div>
                            <div className="  text-end">
                              {Number(
                                Math.floor(
                                  parseFloat(service.total_principal_bhd)
                                )
                              ).toLocaleString()}
                            </div>
                          </div>
                        </div>
                      )}
                    </td>

                    <td className="pt-3">
                      {ltwo || loading ? (
                        <Skeleton width={100} height={15} />
                      ) : (
                        <img
                          onClick={() => dataTopass(service)}
                          className="indiv_loan_dtls_eye Cpointer"
                          src="./images/icons/blue_eye.svg"
                          alt=""
                        />
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  );
};

export default ListofBusinesses;
